import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import styled from "styled-components";
import GlobalStyle from "./styles/global";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ProjectValuesPage from "./pages/ProjectValuesPage";
import CareersPage from "./pages/CareersPage";
import PreRegistrationPage from "./pages/PreRegistrationPage";
import ContactPage from "./pages/ContactPage";
import TarificationPage from "./pages/TarificationPage";
import ScrollToTop from "./components/ScrollToTop";

const PageContainer = styled.div<{ $home?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(p) => (p.$home ? "height: 100dvh;" : "min-height: 100dvh;")}
`;

const ContentWrapper = styled.main<{ $lock?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow: ${(p) => (p.$lock ? "hidden" : "visible")};
`;

const App: React.FC = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <>
      <ScrollToTop />
      <PageContainer $home={isHome}>
        <GlobalStyle />
        <Navbar />
        <ContentWrapper $lock={isHome}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/valeurs" element={<ProjectValuesPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/pre-inscription" element={<PreRegistrationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/tarification" element={<TarificationPage />} />
          </Routes>
          {!isHome && <Footer />}
        </ContentWrapper>
      </PageContainer>
    </>
  );
};

export default App;
